document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('ContactForm');
  if (form) {
    form.setAttribute('action', '/contact');
  }

  const emailInput = document.getElementById('ContactForm-email');
  if (emailInput) {
    emailInput.addEventListener('input', function (event) {
      if (this.validity.typeMismatch || this.validity.patternMismatch) {
        this.setCustomValidity('Please enter a valid email address.');
      } else {
        this.setCustomValidity('');
      }
    });
  }
});
